<template>
  <div class="mt-10 max-w-6xl mx-auto">
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>

    <div class="Polaris-Page__Content" v-if="config.reviews">
      <!-- Automation Settings Section -->
      <div
        class="Polaris-InlineGrid"
        style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 3fr 5fr 4fr; --pc-inline-grid-gap-xs: var(--p-space-400); margin-top: var(--p-space-500);"
      >
        <section
          class="Polaris-Box"
          style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
        >
          <div
            class="Polaris-BlockStack"
            style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
          >
            <h3 class="Polaris-Text--root Polaris-Text--headingMd">
              Automated review requests
            </h3>
            <p class="Polaris-Text--root Polaris-Text--bodyMd">
              We will be sending review requests based on the settings
            </p>
            <div class="mt-4">
              <!-- <a
                target="_blank"
                class="Polaris-Link"
                href="https://configs.carthike.com/images/reviewsampleimage.jpg"
                >Click to view sample Message</a
              > -->
            </div>
          </div>
        </section>

        <div
          class="Polaris-ShadowBevel"
          style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
        >
          <div
            class="Polaris-Box"
            style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
          >
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
            >
              <!-- Alert Banners -->
              <Alert
                v-if="$route.params.appName === 'trustedreviews'"
                :type="'warning'"
                :html="trustedReviewsInstallText"
              />
              <Alert
                v-if="$route.params.appName === 'googlereviews'"
                :type="'info'"
                :html="googleReviewInstallText"
              />

              <!-- Enable Automation -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label class="Polaris-Label__Text">
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Enable automation</span
                      >
                    </label>
                  </div>
                </div>
                <VSwitch
                  :value="
                    config.reviews.isEnabled &&
                      config.reviews.appName === appName
                  "
                  @input="handleSwitch"
                />
                <p
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                >
                  <span v-if="!hasUsingCustomApp">
                    Automated WhatsApp messages are sent from our approved
                    WhatsApp Business API number.
                    <a class="Polaris-Link" @click="sendOwnNumber">
                      Send from own number?
                    </a>
                  </span>
                  <span class="text-blue-500 mt-2" v-if="hasUsingCustomApp"
                    >Automated messages are sent from your brand name and
                    number</span
                  >
                </p>
              </div>

              <!-- Phone Number -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label class="Polaris-Label__Text">
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Phone Number</span
                      >
                    </label>
                  </div>
                </div>
                <vue-tel-input
                  :value="phoneNumber"
                  mode="international"
                  :disabledFetchingCountry="true"
                  @input="handlePhoneNumberUpdate"
                />
                <p
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                >
                  We will share this number as a link where customers can reply
                  to you if they have any concerns.
                </p>
              </div>

              <!-- Review Request Timing -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label
                      id="sendAfterDaysLabel"
                      for="sendAfterDays"
                      class="Polaris-Label__Text"
                    >
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Review request timing</span
                      >
                    </label>
                  </div>
                </div>
                <div class="Polaris-Connected">
                  <div
                    class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                  >
                    <div class="Polaris-TextField">
                      <input
                        id="sendAfterDays"
                        type="number"
                        class="Polaris-TextField__Input"
                        placeholder="number between 1 - 70"
                        aria-labelledby="sendAfterDaysLabel"
                        v-model.number="config.reviews.sendAfterDays"
                        aria-invalid="false"
                      />
                      <div class="Polaris-TextField__Backdrop"></div>
                    </div>
                  </div>
                  <div class="Polaris-Connected__Item">
                    <div class="Polaris-Labelled--hidden">
                      <div class="Polaris-Labelled__LabelWrapper">
                        <div class="Polaris-Label">
                          <label
                            id="sendAfterLabel"
                            for="sendAfter"
                            class="Polaris-Label__Text"
                          >
                            <span
                              class="Polaris-Text--root Polaris-Text--bodyMd"
                              >Send after type</span
                            >
                          </label>
                        </div>
                      </div>
                      <div class="Polaris-Select">
                        <select
                          id="sendAfter"
                          class="Polaris-Select__Input"
                          v-model="config.reviews.sendAfter"
                          aria-invalid="false"
                        >
                          <option value="order_created"
                            >days after order created</option
                          >
                          <option value="order_fulfilled"
                            >days after order fulfilled</option
                          >
                          <option value="order_delivered" disabled
                            >days after order delivered</option
                          >
                        </select>
                        <div class="Polaris-Select__Content" aria-hidden="true">
                          <span class="Polaris-Select__SelectedOption">{{
                            config.reviews.sendAfter === "order_created"
                              ? "days after order created"
                              : config.reviews.sendAfter === "order_fulfilled"
                              ? "days after order fulfilled"
                              : "days after order delivered"
                          }}</span>
                          <span class="Polaris-Select__Icon">
                            <span class="Polaris-Icon">
                              <svg
                                viewBox="0 0 20 20"
                                class="Polaris-Icon__Svg"
                                focusable="false"
                                aria-hidden="true"
                              >
                                <path
                                  d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z"
                                ></path>
                                <path
                                  d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z"
                                ></path>
                              </svg>
                            </span>
                          </span>
                        </div>
                        <div class="Polaris-Select__Backdrop"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Language Selection -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label
                      id="languageSelectLabel"
                      for="languageSelect"
                      class="Polaris-Label__Text"
                    >
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Language</span
                      >
                    </label>
                  </div>
                </div>
                <div class="Polaris-Select">
                  <select
                    id="languageSelect"
                    class="Polaris-Select__Input"
                    v-model="config.reviews.messageLanguage"
                    aria-invalid="false"
                  >
                    <option
                      v-for="(language, index) in templates"
                      :key="index"
                      :value="language.elementName"
                      >{{ language.name }}</option
                    >
                  </select>
                  <div class="Polaris-Select__Content" aria-hidden="true">
                    <span class="Polaris-Select__SelectedOption">
                      {{
                        templates.find(
                          t => t.elementName === config.reviews.messageLanguage
                        )?.name
                      }}
                    </span>
                    <span class="Polaris-Select__Icon">
                      <span class="Polaris-Icon">
                        <svg
                          viewBox="1 1 18 18"
                          class="Polaris-Icon__Svg"
                          focusable="false"
                          aria-hidden="true"
                        >
                          <path
                            d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z"
                          ></path>
                          <path
                            d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                  </div>
                  <div class="Polaris-Select__Backdrop"></div>
                </div>
              </div>

              <!-- Google Review Link (Conditional) -->
              <div class="" v-if="$route.params.appName === 'googlereviews'">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label class="Polaris-Label__Text">
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Google Review Link
                        <a
                          href="https://app.tango.us/app/workflow/Get-Google-Review-Link-74e148bfd3de4560ae15d7bd508450d7"
                          target="_blank"
                          class="Polaris-Link"
                        >
                          How to get the link?
                        </a>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="Polaris-Connected">
                  <div
                    class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                  >
                    <div class="Polaris-TextField">
                      <input
                        class="Polaris-TextField__Input"
                        v-model="config.reviews.reviewLink"
                        placeholder="https://googlereviewlink"
                        type="text"
                        aria-invalid="false"
                      />
                      <div class="Polaris-TextField__Backdrop"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Message Template -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label
                      id="messageTemplateLabel"
                      for="messageTemplate"
                      class="Polaris-Label__Text"
                    >
                      <span class="Polaris-Text--root Polaris-Text--bodyMd">
                        Message
                        <a class="Polaris-Link" @click="customizeMessage">
                          Customize the message?
                        </a>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="Polaris-Connected">
                  <div
                    class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                  >
                    <div
                      class="Polaris-TextField Polaris-TextField--hasValue Polaris-TextField--multiline"
                    >
                      <textarea
                        id="messageTemplate"
                        class="Polaris-TextField__Input"
                        :value="currentTemplate"
                        rows="8"
                        aria-labelledby="messageTemplateLabel"
                        aria-invalid="false"
                        aria-multiline="true"
                        disabled
                      ></textarea>
                      <div class="Polaris-TextField__Backdrop"></div>
                      <div
                        aria-hidden="true"
                        class="Polaris-TextField__Resizer"
                      >
                        <div class="Polaris-TextField__DummyInput">
                          {{ currentTemplate }}
                        </div>
                        <div class="Polaris-TextField__DummyInput">
                          <br /><br /><br /><br /><br /><br /><br /><br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <WhatsappMessagePreview
            v-if="config.reviews"
            :template="getTemplate(config.reviews.messageLanguage)"
          ></WhatsappMessagePreview>
        </div>
      </div>

      <!-- Additional Components -->
      <Notification :text="notificationText" :show="showNotification" />
      <OptinOnboarding :title="optinTitle" />
      <OwnNumberForm
        v-if="showOwnNumberForm"
        @close="showOwnNumberForm = false"
      />
      <TemplateApprovalForm
        :templateType="'reviews'"
        v-if="showTemplateApprovalForm"
        @close="showTemplateApprovalForm = false"
      />
      <AdvancedPlanAlert
        v-if="showAdvancedPlanAlert"
        @close="showAdvancedPlanAlert = false"
      />
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import VSwitch from "../../../components/Common/VSwitch";
import Notification from "../../../components/Common/Notification";
import OptinOnboarding from "../../../components/Common/OptinOnboarding";
import Alert from "../../../components/Common/Alert";
import OwnNumberForm from "../../../components/Forms/OwnNumberForm.vue";
import TemplateApprovalForm from "../../../components/Forms/TemplateApprovalForm.vue";
import AdvancedPlanAlert from "../../../components/Forms/AdvancedPlanAlert.vue";
import { cloneDeep, isEqual } from "lodash-es";

import WhatsappMessagePreview from "../../../components/Common/WhatsappMessagePreview.vue";
import customApp from "../../../Mixins/customApp";

export default {
  name: "AutomatedConfigureForm",
  mixins: [customApp],
  components: {
    VueTelInput,
    VSwitch,
    Notification,
    OptinOnboarding,
    Alert,
    OwnNumberForm,
    TemplateApprovalForm,
    AdvancedPlanAlert,
    WhatsappMessagePreview
  },

  data() {
    return {
      phoneNumber: "",
      notificationText: "",
      showNotification: false,
      config: {},
      originalConfig: {},
      templates: [],
      showModal: false,
      appName: "",
      optinTitle:
        "Get more reviews by collecting WhatsApp opt-in from Checkout page (Mandatory)",
      trustedReviewsInstallText:
        "If TrustReviews app is not installed, Please install the app here  <a href='https://apps.shopify.com/trustreviews' target='_blank'>https://apps.shopify.com/trustreviews</a>",
      googleReviewInstallText:
        "We also have an app to showcase your google reviews on your store. Please install the app here <a href='https://apps.shopify.com/google-reviews' target='_blank'>https://apps.shopify.com/google-reviews</a>",
      showOwnNumberForm: false,
      showTemplateApprovalForm: false,
      showAdvancedPlanAlert: false,
      saveBar: null,
      isLoading: false
    };
  },

  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },

  computed: {
    currentTemplate() {
      const template = this.templates.find(
        template => template.elementName === this.config.reviews.messageLanguage
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template?.message;
    },
    discountUrl() {
      const { shopOrigin } = this.$store.getters.getStore;
      return `https://${shopOrigin}/admin/discounts/`;
    }
  },

  created() {
    this.init();
    this.updateOnboadingFlag();
    this.appName = this.$route.params.appName;
    this.checkForCustomApp();
  },

  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },

  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.config = response.config;
        this.originalConfig = cloneDeep(response.config);
        this.templates = response.reviewTemplates;
        this.phoneNumber = this.config.phoneNumber;
        this.isLoading = false;
      });
    },

    checkForChanges() {
      if (!isEqual(this.config, this.originalConfig)) {
        this.saveBar.show();
      } else {
        this.saveBar.hide();
      }
    },

    onSaveBarSaveClicked() {
      this.save();
      this.saveBar.hide();
    },

    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.saveBar.hide();
    },

    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, event) {
      if (this.config.phoneNumber != event.number && event.number) {
        this.config.phoneNumber = event.number;
      }
    },
    save() {
      if (this.hasMoreCharacters) {
        alert("Button Label should be less than 12 characters");
        return;
      }
      if (
        this.$route.params.appName === "googlereviews" &&
        (!this.config.reviews.reviewLink ||
          this.config.reviews.reviewLink.length === 0)
      ) {
        alert(
          "Google reviews link is mandatory. Please Contact support to get the link."
        );
        return;
      }
      this.updateConfig();
    },
    handleSwitch(value) {
      this.config.reviews.isEnabled = value;
      this.config.reviews.appName = this.appName;
    },
    updateConfig() {
      this.config.reviews.appName = this.$route.params.appName;
      const automationConfig = { ...this.config };
      this.$store
        .dispatch("updateAutomationConfig", { requestParams: automationConfig })
        .then(() => {
          this.displayNotification("settings updated");
          this.originalConfig = cloneDeep(this.config);
        });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    openOptinModal() {
      this.showModal = true;
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isLooxIntegrationVisited"
        }
      });
    },
    customizeMessage() {
      const { plan } = this.$store.getters.getStore;
      if (plan != "advanced") {
        this.showAdvancedPlanAlert = true;
      } else {
        this.showTemplateApprovalForm = true;
      }
    },
    sendOwnNumber() {
      const { plan } = this.$store.getters.getStore;
      if (plan != "advanced") {
        this.showAdvancedPlanAlert = true;
      } else {
        this.showOwnNumberForm = true;
      }
    },
    getTemplate(elementName) {
      const template = this.templates.find(
        template => template.elementName === elementName
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template;
    }
  }
};
</script>

<style lang="scss" scoped></style>
